export default "__VITE_ASSET__DFTccnoT__"